// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2jUzT","colBig":"styles_colBig__1Ap-5","colSmall":"styles_colSmall__YmhSh","shopifyNameWrapper":"styles_shopifyNameWrapper__3qZG-"};